import { cn } from '@/lib/utils';
import { Separator } from './ui/separator';

interface CardProps {
  title?: React.ReactNode;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
const Card: React.FC<CardProps> = ({
  title,
  description,
  actions,
  children,
  className,
}) => (
  <div
    className={cn('w-full rounded-md dark:border', className)}
    style={{
      boxShadow:
        'inset 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 10px 3px rgba(0, 0, 0, 0)',
    }}
  >
    {title && (
      <>
        <div className='flex flex-col items-center justify-between px-4 py-2 md:flex-row'>
          <div>
            <h2 className='text-[1rem] font-semibold md:text-[1.25rem] lg:text-[1.5rem]'>
              {title}
            </h2>
            <p className='text-[0.75rem] text-muted-foreground md:text-[0.875rem] lg:text-[1rem]'>
              {description}
            </p>
          </div>

          <div className='flex flex-col gap-2 md:flex-row'>{actions}</div>
        </div>

        <Separator />
      </>
    )}
    <div className='w-full rounded-md p-4'>{children}</div>
  </div>
);

export default Card;
